import { render, staticRenderFns } from "./ForteTaxPayment.vue?vue&type=template&id=3a0f4cd3&"
import script from "./ForteTaxPayment.vue?vue&type=script&lang=js&"
export * from "./ForteTaxPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports